import { useQueryClient } from "react-query"
import { TApiProject } from "../../api-client/types"

interface Props {
  projectId: string
}

export const useGetProject = (props: Props) => {
  const {
    projectId
  } = props

  const queryClient = useQueryClient()
  const cachedData = queryClient.getQueriesData<{ project: TApiProject }>(['projects'])

  //console.warn(cachedData)

  for (const [,result] of cachedData) {
    if (!result) continue

    if (result.project?.id == projectId) {
      return result.project
    }
  }

  return null
 }